/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Irrigation_Pump_Cooldown_HintInputs */

const vi_irrigation_pump_cooldown_hint = /** @type {(inputs: Irrigation_Pump_Cooldown_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bật lại sau ${i?.time}`)
};

/**

* @param {Irrigation_Pump_Cooldown_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_pump_cooldown_hint = /** @type {((inputs: Irrigation_Pump_Cooldown_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Pump_Cooldown_HintInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_pump_cooldown_hint(inputs)
});